module.exports = __webpack_public_path__ + "img/icon_smart_energy.c2e58a64.png";